import { PortalData } from './../common/Portal/index';

export function getShowCost(portalData: PortalData | undefined): boolean {
  return portalData?.portalConfig?.showCost !== false;
}